import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function TopBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="bg-ink text-amber py-2 px-4 sticky top-0 z-50 border-b border-amber/20 text-center text-sm md:text-base font-medium" data-id="element-223">
      <p data-id="element-224">
        ⏰ Launch Price Ends In:{' '}
        <span className="font-bold font-display tracking-wider text-lg" data-id="element-225">
          {formatTime(hours)}:{formatTime(minutes)}:{formatTime(seconds)}
        </span>{' '}
        — Lock In Your Discount Now
      </p>
    </div>;
}